<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            id="autorizacoes.voltarBtn"
            color="primary"
            text
            x-small
            @click="() => $router.back()"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Pedido de Autorização
        </h1>
      </v-col>
    </v-row>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form
        id="autorizacoes.form"
        @submit.prevent="handleSubmit(submitForm)"
        :disabled="submittingForm"
      >
        <v-row>
          <v-col class="pt-0 pb-0" cols="2">
            <e-label>Etapa</e-label>
            <p id="autorizacoes.etapaText">
              {{ etapaInfo.descricao }}
            </p>
          </v-col>

          <v-col class="pt-0 pb-0" cols="4">
            <ValidationProvider name="Solicitação" rules="required" v-slot="{ errors }">
              <e-label>Solicitação</e-label>

              <e-autocomplete
                id="autorizacoes.pedidoSelect"
                v-model="formAutorizacao.pedido_id"
                dense
                :error-messages="errors"
                :items="pedidos"
                :item-text="(item) => item.descricao"
                :item-value="(item) => item.id"
                label="Selecione um tipo"
                :return-object="false"
                solo
              />
            </ValidationProvider>
          </v-col>

          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider name="Avaliador" rules="required" v-slot="{ errors }">
              <e-label>Avaliador</e-label>

              <e-autocomplete
                id="autorizacoes.userAprovadorSelect"
                v-model="formAutorizacao.user_aprovador"
                dense
                :error-messages="errors"
                :items="outrosUsuariosList"
                :item-text="(item) => item.name"
                :item-value="(item) => item.id"
                label="Selecione um Usuário"
                :return-object="false"
                solo
              />
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pt-0 pb-0" cols="12">
            <ValidationProvider name="Descrição" rules="" v-slot="{ errors }">
              <e-label>Observações</e-label>

              <v-textarea
                id="autorizacoes.observacoesInput"
                v-model="formAutorizacao.observacoes"
                dense
                :error-messages="errors"
                solo
                v-on:change="(value) => deixarLetraMinuscula(value, 'observacoes')"
              />
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn
              id="autorizacoes.enviarDadosBtn"
              block
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
            >
              Enviar Dados
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<style></style>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "@/store";
import { dateFormatParam } from "../../../plugins/filters";
import ELabel from "../../../components/ELabel.vue";
import Usuario from "../../../Models/User";

export default {
  components: { ELabel },

  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      attrs: null,
      autorizacaoId: null,
      data_final: null,
      data_inicial: null,
      etapaInfo: [],
      modalFim: false,
      modalInicio: false,
      on: null,
      outrosUsuariosList: [],
      pedidos: [
        {
          id: 1,
          descricao: "LANÇAR AULAS FORA DO PERIODO",
        },
      ],
      submittingForm: false,
      users: [
        {
          id: 1,
          name: "pedro",
        },
        {
          id: 2,
          name: "joao",
        },
      ],
    };
  },

  computed: {
    ...mapGetters("Autorizacoes", ["autorizacoes", "autorizacoesList"]),
    ...mapGetters("Etapas", ["etapas", "etapasList"]),

    formAutorizacao() {
      if (!this.autorizacoes || !this.editing) return {};

      const { autorizacao_id } = this.$route.params;

      const autorizacao = this.autorizacoesList
        .filter((cir) => cir.id === parseInt(autorizacao_id, 10))
        .shift();

      return { ...autorizacao };
    },
  },

  watch: {
    data_final(value) {
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );

      this.formAutorizacao.tempo_final = data_old.replaceAll("/", "/");
    },

    data_inicial(value) {
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );

      this.formAutorizacao.tempo_inicial = data_old.replaceAll("/", "/");
    },
  },

  async mounted() {
    await this.verificarEtapa();
    this.loadData();
    this.carregarUsuarios(1);
  },

  methods: {
    ...mapActions("Autorizacoes", ["loadAutorizacoes"]),

    async carregarUsuarios(pageNumber, query = null) {
      try {
        const response = await this.$services.autorizacoesService.getUsuarioAdmin();

        const usuarios = Array.isArray(response.data)
          ? response.data.map((usuario) => new Usuario(usuario))
          : [new Usuario(response.data)];

        console.log(usuarios);

        this.outrosUsuariosList = usuarios;
      } catch (error) {
        this.$handleError(error);
      }
    },

    deixarLetraMinuscula(value, campo) {
      const novo_valor = value.toLowerCase().split(" ");

      const valor = novo_valor
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      this.formAutorizacao[campo] = valor;
    },

    async loadData() {
      try {
        if (this.autorizacoes.length === 0) {
          this.$loaderService.open("Carregando dados");

          await Promise.all([this.loadAutorizacoes()]);
          this.$loaderService.close();
        }

        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
    },

    setCircuito(autorizacao) {
      this.autorizacaoId = autorizacao.id;
    },

    async submitForm() {
      const { etapa } = this.$route.params;

      this.submittingForm = true;
      this.formAutorizacao.status = "PENDENTE";

      const currentUser = store.getters["Auth/user"];

      this.formAutorizacao.user_solicitante = currentUser.id;
      this.formAutorizacao.etapa_id = etapa;

      try {
        if (this.editing) {
          await this.$services.autorizacoesService.atualizarAutorizacao(this.formAutorizacao);
        } else {
          await this.$services.autorizacoesService.criarAutorizacao(this.formAutorizacao);
        }

        this.$toast.success("Pedido enviado com sucesso");
        this.$router.back();
      } catch (error) {
        this.$handleError(error);
      }

      this.submittingForm = false;
    },

    verificarEtapa() {
      this.etapaInfo =
        this.etapasList.find((etapa) => etapa.id === parseInt(this.$route.params.etapa, 10)) || {};
    },
  },
};
</script>

<style></style>
